<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资金管理</el-breadcrumb-item>
                <el-breadcrumb-item>银行账户管理</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-form label-width="70px" class="search-form">
            <el-row>
                <el-form-item label="关键词" prop="keyword">
                    <el-col>
                        <el-input v-model="query.keyword" prefix-icon="Search" placeholder="输入账户别名、账户号、账户名或银行名称"
                            @keyup.enter="fetchs()">
                        </el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="search" @click="fetchs()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-button type="primary" icon="plus" @click="addBank()">新增银行账户</el-button>
            <el-button type="danger" icon="delete" @click="deleter()">删除</el-button>

            <el-dropdown style="margin-left:20px;">
                <el-button plain type="primary">
                    <el-icon style="margin-right:5px;">
                        <Upload />
                    </el-icon>
                    数据操作
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="download()">导出信息</el-dropdown-item>
                        <el-dropdown-item @click="visible = true">批量导入</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:bankType="scope">
                <el-tag :type="scope.row.bankType === 'Corporate' ? 'primary' : 'success'">
                    {{ scope.row.bankType === 'Corporate' ? '企业账户' : '个人账户' }}
                </el-tag>
            </template>

            <template v-slot:sortCode="scope">
                <el-tag v-if="scope.row.sortCode" type="info">{{ scope.row.sortCode }}</el-tag>
                <span v-else>-</span>
            </template>

            <template v-slot:toolbar="scope">
                <el-button plain @click="viewBank(scope.row)" type="info" size="small">查看</el-button>
                <el-button plain @click="editBank(scope.row)" type="primary" size="small"
                    style="margin-left:5px;">编辑</el-button>
                <el-button plain @click="deleteBank(scope.row)" type="danger" size="small"
                    style="margin-left:5px;">删除</el-button>
            </template>
        </basic-table>

        <!-- 查看/编辑银行账户弹框 -->
        <el-dialog v-model="dialogVisible" :title="dialogTitle" width="800px" destroy-on-close @close="closeDialog">

            <el-form ref="bankForm" :model="bankForm" :rules="bankRules" label-width="120px" class="bank-form">

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="账户别名" prop="cardAlias">
                            <el-input v-model="bankForm.cardAlias" placeholder="请输入账户别名" maxlength="80" show-word-limit
                                :disabled="isView">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="银行账户" prop="cardNo">
                            <el-input v-model="bankForm.cardNo" placeholder="请输入银行账户号" maxlength="50"
                                :disabled="isView">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="账户名" prop="cardName">
                            <el-input v-model="bankForm.cardName" placeholder="请输入账户名" maxlength="80"
                                :disabled="isView">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="银行类型" prop="bankType">
                            <el-select v-model="bankForm.bankType" placeholder="请选择银行类型" style="width: 100%"
                                :disabled="isView">
                                <el-option label="企业账户" value="Corporate"></el-option>
                                <el-option label="个人账户" value="Personal"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="银行名称" prop="bankName">
                            <el-input v-model="bankForm.bankName" placeholder="请输入银行名称" maxlength="50"
                                :disabled="isView">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="银行英文缩写" prop="bankAbbr">
                            <el-input v-model="bankForm.bankAbbr" placeholder="如：icbc、ccb、abc" maxlength="80"
                                :disabled="isView">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="分行名称" prop="branchName">
                            <el-input v-model="bankForm.branchName" placeholder="请输入分行名称" maxlength="50"
                                :disabled="isView">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联行号" prop="branchCode">
                            <el-input v-model="bankForm.branchCode" placeholder="请输入联行号" maxlength="50"
                                :disabled="isView">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排序码" prop="sortCode">
                            <el-input-number v-model="bankForm.sortCode" :min="0" :max="9999" placeholder="排序码"
                                style="width: 100%;max-width: 150px;" :disabled="isView">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="分行地址" prop="branchAddr">
                    <el-input v-model="bankForm.branchAddr" type="textarea" :rows="2" placeholder="请输入分行地址"
                        maxlength="100" show-word-limit :disabled="isView">
                    </el-input>
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input v-model="bankForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息" maxlength="200"
                        show-word-limit :disabled="isView">
                    </el-input>
                </el-form-item>


            </el-form>

            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button v-if="!isView" type="primary" @click="submitBank">
                        {{ isEdit ? '更新' : '保存' }}
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 批量导入组件 -->
        <component ref="dialog" :visible="visible" @change="changeHandler" @submit="submitHandler"
            :columns="query.columns" is="importer" />
    </el-card>
</template>

<script>
import BasicTable from "@/components/basic-table.vue";

export default {
    name: "FundBankInfo",
    components: { BasicTable },
    data() {
        return {
            query: {
                keyword: "",
                columns: [
                    { type: "index", label: "序号" },
                    { prop: "cardAlias", label: "账户别名", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },
                    { prop: "cardNo", label: "银行账户", sortable: true, searchable: true, width: "180", showOverflowTooltip: true },
                    { prop: "cardName", label: "账户名", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
                    { prop: "bankName", label: "银行名称", sortable: true, searchable: true, width: "100", showOverflowTooltip: true },
                    { prop: "bankAbbr", label: "银行缩写", width: "90", showOverflowTooltip: true },
                    { type: "template", prop: "bankType", label: "账户类型", width: "90", align: "center" },
                    { prop: "branchName", label: "分行名称", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
                    { prop: "branchCode", label: "联行号", width: "100", showOverflowTooltip: true },
                    { type: "template", prop: "sortCode", label: "排序码", width: "80", align: "center" },
                    { prop: "branchAddr", label: "分行地址", width: "180", showOverflowTooltip: true },
                    { prop: "remark", label: "备注", width: "150", showOverflowTooltip: true },

                    { prop: "createUserName", label: "创建人", searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "createDate", label: "创建时间", sortable: true, width: "160", showOverflowTooltip: true },
                    { prop: "updateUserName", label: "更新人", searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "updateDate", label: "更新时间", sortable: true, width: "160", showOverflowTooltip: true },

                    { type: "toolbar", label: "操作", width: "220", fixed: "right" },
                ],
                filters: [],
                sidx: "sortCode",
                sord: "asc"
            },
            visible: false,

            // 弹框相关数据
            dialogVisible: false,
            dialogTitle: '',
            isEdit: false,
            isView: false,

            // 表单数据
            bankForm: {
                id: '',
                cardAlias: '',
                cardNo: '',
                cardName: '',
                bankAbbr: '',
                bankName: '',
                bankType: '',
                branchName: '',
                branchCode: '',
                branchAddr: '',
                sortCode: null,
                remark: ''
            },

            // 表单验证规则
            bankRules: {
                cardAlias: [
                    { required: true, message: '请输入账户别名', trigger: 'blur' },
                    { max: 80, message: '账户别名不能超过80个字符', trigger: 'blur' }
                ],
                cardNo: [
                    { required: true, message: '请输入银行账户', trigger: 'blur' },
                    { max: 50, message: '银行账户不能超过50个字符', trigger: 'blur' }
                ],
                cardName: [
                    { required: true, message: '请输入账户名', trigger: 'blur' },
                    { max: 80, message: '账户名不能超过80个字符', trigger: 'blur' }
                ],
                bankAbbr: [
                    { required: true, message: '请输入银行英文缩写', trigger: 'blur' },
                    { max: 80, message: '银行英文缩写不能超过80个字符', trigger: 'blur' }
                ],
                bankName: [
                    { required: true, message: '请输入银行名称', trigger: 'blur' },
                    { max: 50, message: '银行名称不能超过50个字符', trigger: 'blur' }
                ],
                bankType: [
                    { required: true, message: '请选择银行类型', trigger: 'change' }
                ],
                branchName: [
                    { max: 50, message: '分行名称不能超过50个字符', trigger: 'blur' }
                ],
                branchCode: [
                    { max: 50, message: '联行号不能超过50个字符', trigger: 'blur' }
                ],
                branchAddr: [
                    { max: 500, message: '分行地址不能超过500个字符', trigger: 'blur' }
                ],
                remark: [
                    { max: 500, message: '备注不能超过500个字符', trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        //kaung插件初始化
        this.$kaung.init(this.$options.name);
        this.fetchs();
    },
    methods: {
        fetchs() {
            let { data, records, total, ...params } = { ...this.query };
            this.$kaung.search(params).then((res) => {
                this.query = { ...res.data };
            });
        },
        download() {
            let { data, records, total, ...params } = { ...this.query };
            this.$kaung.export(params).then((res) => {
                this.$notify({
                    title: '表格数据导出',
                    message: res.content,
                    type: res.type,
                    duration: 10000
                });
                window.location.href = process.env.VUE_APP_BASEURL + res.data;
            });
        },

        deleter() {
            if (!this.$refs.table.chooseRow) {
                this.$message({ message: '请点击选择要删除的数据行', type: 'warning' });
                return;
            }

            let that = this;
            this.$confirm("此操作将删除本页选择数据, 是否继续?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
                .then(() => {
                    this.$kaung.delete(that.$refs.table.chooseRow.id).then((res) => {
                        if (res.code === 200) {
                            that.$message({ message: res.content, type: res.type });
                            that.fetchs();
                        }
                    });
                });
        },

        changeHandler(value) {
            this.visible = value;
        },
        submitHandler(lists) {
            this.$kaung.fetch({ url: this.$options.name + '/Importer', data: lists }).then((res) => {
                if (res.code === 200) {
                    this.$message({ message: res.content, type: res.type });
                    this.fetchs();
                }
            });
        },

        // 新增银行账户
        addBank() {
            this.resetForm();
            this.isEdit = false;
            this.isView = false;
            this.dialogTitle = '新增银行账户';
            this.dialogVisible = true;
        },

        // 查看银行账户
        viewBank(row) {
            this.resetForm();
            this.isEdit = false;
            this.isView = true;
            this.dialogTitle = '查看银行账户';

            // 先打开弹框
            this.dialogVisible = true;

            // 加载完整数据
            this.$kaung.getone(row.id).then((res) => {
                if (res.code === 200) {
                    Object.keys(this.bankForm).forEach(key => {
                        if (res.data.hasOwnProperty(key)) {
                            this.bankForm[key] = res.data[key];
                        }
                    });
                }
            });
        },

        // 编辑银行账户
        editBank(row) {
            this.resetForm();
            this.isEdit = true;
            this.isView = false;
            this.dialogTitle = '编辑银行账户';

            // 先打开弹框
            this.dialogVisible = true;

            // 加载完整数据
            this.$kaung.getone(row.id).then((res) => {
                if (res.code === 200) {
                    Object.keys(this.bankForm).forEach(key => {
                        if (res.data.hasOwnProperty(key)) {
                            this.bankForm[key] = res.data[key];
                        }
                    });
                }
            });
        },

        // 删除单个银行账户
        deleteBank(row) {
            this.$confirm("此操作将删除该银行账户信息，是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$kaung.delete(row.id).then((res) => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.fetchs();
                    }
                });
            });
        },

        // 重置表单
        resetForm() {
            this.bankForm = {
                id: '',
                cardAlias: '',
                cardNo: '',
                cardName: '',
                bankAbbr: '',
                bankName: '',
                bankType: '',
                branchName: '',
                branchCode: '',
                branchAddr: '',
                sortCode: null,
                remark: ''
            };

            if (this.$refs.bankForm) {
                this.$refs.bankForm.clearValidate();
            }
        },

        // 提交银行账户表单
        submitBank() {
            if (this.isView) {
                this.dialogVisible = false;
                return;
            }

            this.$refs.bankForm.validate((valid) => {
                if (!valid) return;

                // 只传递业务字段，不包含创建和更新相关字段
                let submitData = {
                    cardAlias: this.bankForm.cardAlias,
                    cardNo: this.bankForm.cardNo,
                    cardName: this.bankForm.cardName,
                    bankAbbr: this.bankForm.bankAbbr,
                    bankName: this.bankForm.bankName,
                    bankType: this.bankForm.bankType,
                    branchName: this.bankForm.branchName,
                    branchCode: this.bankForm.branchCode,
                    branchAddr: this.bankForm.branchAddr,
                    sortCode: this.bankForm.sortCode,
                    remark: this.bankForm.remark
                };

                this.$kaung.submit({
                    id: this.isEdit ? this.bankForm.id : null,
                    data: submitData
                }).then((res) => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.dialogVisible = false;
                        this.fetchs();
                    }
                });
            });
        },

        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false;
            this.resetForm();
        }
    },
};
</script>

<style scoped>
.bank-form {
    padding: 20px 0;
}

.bank-form .el-form-item {
    margin-bottom: 18px;
}

.toolbar {
    margin-bottom: 20px;
}

.toolbar .el-button {
    margin-right: 10px;
}

.el-divider {
    margin: 20px 0;
}

.dialog-footer {
    text-align: right;
}

.dialog-footer .el-button {
    margin-left: 10px;
}
</style>
